import React, { useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import '../../styles/Contact.css'; 
import '../../styles/Fonts.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const ContactForm = () => {
  const [selectedSubject, setSelectedSubject] = useState("general-inquiry");
  const [state, handleSubmit] = useForm("xbljrajk");

  const handleRadioChange = (e) => {
    setSelectedSubject(e.target.value);
  };

  return (
    <section className="contact-section">
      <div className="container">
        <div className="contact-container-card">
          <div className="row g-0">
            {/* Left Side: Contact Info */}
            <div className="col-lg-4 col-md-5 contact-info-section">
              <h2 className="contact-info-title">Contact Information</h2>
              <p className="contact-info-description">We'd love to hear from you. Get in touch!</p>
              <div className="contact-info-items">
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-phone"></i>
                  </div>
                  <p className="contact-info-text">(02) 88250200 (HOTLINE)</p>
                </div>
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-phone"></i>
                  </div>
                  <p className="contact-info-text">+63 917 709 6992</p>
                </div>
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <p className="contact-info-text">sales@rcsphil.com</p>
                </div>
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <p className="contact-info-text">
                    Retail C, GF, BM ONE Building Amvel Business Park Ninoy Aquino Ave San Dionisio, Paranaque
                  </p>
                </div>
              </div>
            </div>  

            {/* Right Side: Form or Thank You Message */} 
            <div className="col-lg-8 col-md-7 contact-form-section">
              {state.succeeded ? (
                <div className="thank-you-section">
                  <div className="thank-you-icon">
                    <i className="fas fa-check"></i>
                  </div>
                  <h3 className="thank-you-title">Thank You for Contacting Us!</h3>
                  <p className="thank-you-text">
                    We have received your message and will get back to you within 24-48 hours.
                  </p>
                  <p className="thank-you-text">
                    In the meantime, please check your email for a confirmation. If you don't see it, 
                    kindly check your spam or junk folder. We appreciate your patience!
                  </p>
                </div>
            
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="firstName">First Name</label>
                        <input 
                          type="text" 
                          className="form-input" 
                          id="firstName" 
                          name="firstName" 
                          placeholder="Enter your first name"
                          required 
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="lastName">Last Name</label>
                        <input 
                          type="text" 
                          className="form-input" 
                          id="lastName" 
                          name="lastName" 
                          placeholder="Enter your last name"
                          required 
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="email">Email Address</label>
                        <input 
                          type="email" 
                          className="form-input" 
                          id="email" 
                          name="email" 
                          placeholder="Enter your email address"
                          required 
                        />
                        <ValidationError 
                          prefix="Email" 
                          field="email"
                          errors={state.errors}
                          className="form-error"
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="phone">Phone Number</label>
                        <input 
                          type="tel" 
                          className="form-input" 
                          id="phone" 
                          name="phone" 
                          placeholder="Enter your phone number"
                          required 
                        />
                      </div>
                    </div>
                  </div>

                  <div className="subject-section">
                    <div className="subject-title">What can we help you with?</div>
                    <div className="subject-options">
                      <div className="subject-option">
                        <input
                          className="subject-radio"
                          type="radio"
                          id="generalInquiry"
                          name="subject"
                          value="general-inquiry"
                          checked={selectedSubject === "general-inquiry"}
                          onChange={handleRadioChange}
                        />
                        <label className="subject-label" htmlFor="generalInquiry">General Inquiry</label>
                      </div>
                      <div className="subject-option">
                        <input
                          className="subject-radio"
                          type="radio"
                          id="getAQuote"
                          name="subject"
                          value="get-a-quote"
                          checked={selectedSubject === "get-a-quote"}
                          onChange={handleRadioChange}
                        />
                        <label className="subject-label" htmlFor="getAQuote">Get a Quote</label>
                      </div>
                      <div className="subject-option">
                        <input
                          className="subject-radio"
                          type="radio"
                          id="customerService"
                          name="subject"
                          value="customer-service"
                          checked={selectedSubject === "customer-service"}
                          onChange={handleRadioChange}
                        />
                        <label className="subject-label" htmlFor="customerService">Customer Service</label>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label" htmlFor="message">Your Message</label>
                    <textarea 
                      className="form-textarea" 
                      id="message" 
                      name="message" 
                      placeholder="Tell us about your logistics needs..."
                      required
                    ></textarea>
                    <ValidationError 
                      prefix="Message" 
                      field="message"
                      errors={state.errors}
                      className="form-error"
                    />
                  </div>

                  <div className="text-end">
                    <button 
                      type="submit" 
                      className={`submit-button ${state.submitting ? 'loading' : ''}`}
                      disabled={state.submitting}
                    >
                      {state.submitting ? '' : 'Send Message'}
                    </button>
                  </div>
              </form>
            )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
